import axiosInstance from "../config/axiosInstance";
import { API_ENDPOINTS } from "../config/api";

export const rawDataConvert = (params: { code: string; type: number | null | undefined; toType: number | null | undefined }) =>
  axiosInstance.get(API_ENDPOINTS.rawDataConvert, { params });

export const parseToConvert = (params: { payload: string; parseType: number; convertType: number }) =>
  axiosInstance.get(API_ENDPOINTS.parseToConvert, { params });
